// src/sources/languages.ts

export const localeCodes = {
  ar: 'العربية',
  bg: 'Български',
  ca: 'Català',
  ca_ES: 'Català (Espanya)',
  cs: 'Čeština',
  da: 'Dansk',
  da_DK: 'Dansk (Danmark)',
  de: 'Deutsch',
  de_AT: 'Deutsch (Österreich)',
  el: 'Ελληνικά',
  el_GR: 'Ελληνικά (Ελλάδα)',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  fr_CA: 'Français (Canada)',
  fr_FR: 'Français (France)',
  he: 'עברית',
  hu: 'Magyar',
  it: 'Italiano',
  it_IT: 'Italiano (Italia)',
  ja: '日本語',
  ko: '한국어',
  mi_NZ: 'Maori (Aoteara New Zealand)',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português',
  pt_BR: 'Português (Brasil)',
  pt_PT: 'Português (Portugal)',
  ru: 'Русский',
  sl: 'Slovenščina',
  sl_SI: 'Slovenščina (Slovenija)',
  sv: 'Svenska',
  sv_SE: 'Svenska (Sverige)',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  zh: '中文 (简体)',
};
